/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/PreUpdate/Content/SentImmediately/Content"
  
}) {
let constantData = '•'
let automationUpdateImpactSentImmediatelyValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'update_impact.sent_immediately',
})
let constantData1 = 'reminders will be sent immediately and marked as completed'
let aggregateData = fromAggregate.join(constantData, automationUpdateImpactSentImmediatelyValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'•'"
 data="automation.update_impact.sent_immediately"
 data="'reminders will be sent immediately and marked as completed'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}